import React from 'react'
import Input from 'app/theme/forms/Input'

export default function ListingYearFilter({ start, end, update }) {
  return (
    <div className="my-6 md:my-0">
      <h3 className="text-md text-black font-bold mb-4">Year</h3>
      <div className="flex items-center">
        <Input
          type="number"
          value={start}
          placeholder="From"
          onChange={min => {
            update('min_year', min)
          }}
        />
        <span className="px-2">&mdash;</span>
        <Input
          type="number"
          value={end}
          placeholder="To"
          onChange={max => {
            update('max_year', max)
          }}
        />
      </div>
    </div>
  )
}
